import React, { Component } from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';
import { Row, Col, Container } from 'reactstrap';
import { getCollectionPrefix } from '../../../actions/kafairAction';

class StealDeals extends Component {
  constructor(props) {
    super(props);
    this.state = {

    }
  }

  componentDidMount() {
    const payload = {
      prefix_slug: "steal-deal"
    }
    this.props.getCollectionPrefix(payload, "steal_deal");
  }

  goToProductList = (name, slug) => {
    const newSlug = name ? name.replace(/\s/g, "-").toLowerCase() : "steal-deal"

    this.props.history.push({
      pathname: `/kafair/${newSlug}`,
      state: { slug }
    })
  }


  render() {
    const { data } = this.props

    if (data.dataList.length === 0) return null
    return (
      <Container fluid className="steal-deals-container section">
        <div className="title-section">
          <span>Fairgrounds</span>
          <span>Shop according to your budget</span>
        </div>
        <Row className="steal-deals-wrapper">
          {
            data.dataList.map((item, index) => {
              const imageUrl = item.default_images.length > 0 && item.default_images[0].URL
              const imgBg = item.categories.length > 0 && item.categories[0].pivot.images.length > 0 && item.categories[0].pivot.images.find(item => item.orientation === "landscape")

              return (
                <Col md={3} xs={6}>
                  <div className="steal-deal-card" onClick={() => this.goToProductList(item.name, item.slug)}>
                    <KickImage src={imgBg ? imgBg.URL : ""} className="steal-img" />
                    {/* <span>{item.name} Present</span> */}
                    <span>{item.description}</span>
                  </div>
                </Col>
              )
            })
          }
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  data: state.dataKaFair.steal_deal
})

const mapDispatchToProps = dispatch => ({
  getCollectionPrefix: (payload, name) => dispatch(getCollectionPrefix(payload, name))
})

export default connect(mapStateToProps, mapDispatchToProps)(StealDeals);